import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-flotte-automobile',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent],
  templateUrl: './assurance-flotte-automobile.component.html',
  styleUrls: ['./assurance-flotte-automobile.component.scss']
})
export class AssuranceFlotteAutomobileComponent {
  title = 'Assurance Flotte Auto Professionnelle';
  subtitle = '';
  heroVideo = 'assets/videos/auto-perso.mp4';

  breadcrumbs = [
    { label: 'Entreprises', link: undefined },
    { label: 'Assurance Flotte Auto Professionnelle', link: undefined }
  ];

  prevPage = { 
    title: 'Assurance Moto Professionnelle',
    link: '/assurance-moto-professionnelle'
  };

  nextPage = { 
    title: 'Assurance Flotte Moto Professionnelle',
    link: '/assurance-flotte-moto-professionnelle'
  };

  partners = [
    { name: 'GENERALI', logo: 'assets/images/logos/generali-logo.png' },
    { name: 'SWISSLIFE', logo: 'assets/images/logos/swisslife-logo.png' },
    { name: 'ALPTIS', logo: 'assets/logos/ALPTIS.PNG' },
    { name: 'MALAKOFF HUMANIS', logo: 'assets/logos/MALAKOFF.PNG' }
  ];
}
